import { querySharedServices } from '@/src/domains/shared/services';
import { queryPreemploymentFAQPage } from '@/src/views/EmploymentFAQ/PreemploymentFAQ/services';

export { PreemploymentFAQPage as default } from '@/src/views/EmploymentFAQ/PreemploymentFAQ';

export async function getStaticProps({ preview = false, previewData = {}, locale }) {
  const employmentFAQData = await queryPreemploymentFAQPage({ previewData, locale });
  const sharedServices = await querySharedServices({ previewData, locale });

  if (!employmentFAQData) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      sharedServices,
      ...employmentFAQData,
    },
  };
}
